import React from "react"
import { Doughnut } from "react-chartjs-2"
import { Chart, registerables } from "chart.js"
import ChartDataLabels from "chartjs-plugin-datalabels"
import { useSelector } from "react-redux"
import { layoutModeTypes } from "constants/layout"
import Colors from "constants/Colors"

// Register Chart.js components & plugins
Chart.register(...registerables, ChartDataLabels)
const centerTextPlugin = {
  id: "centerText",
  beforeDraw: chart => {
    const { width, height, ctx } = chart
    const text = chart.config.options.centerText?.text || ""
    const fontSize = chart.config.options.centerText?.fontSize || "16"
    const fontColor = chart.config.options.centerText?.color || "#000"

    ctx.save()
    ctx.font = `${fontSize}px sans-serif`
    ctx.fillStyle = fontColor
    ctx.textAlign = "center"
    ctx.textBaseline = "middle"
    ctx.fillText(text, width / 2, height / 2)
    ctx.restore()
  },
}

Chart.register(centerTextPlugin)

const DountChart = ({ data, options, label }) => {
  const layoutMode = useSelector(state => state.Layout.layoutModeType)

  const chartOptions = {
    ...options,
    centerText: {
      text: label || "",
      fontSize: 18,
      color: layoutMode === layoutModeTypes.LIGHT ? Colors.black : Colors.white,
    },
  }
  return (
    <Doughnut
      width={734}
      height={269}
      className="chartjs-chart"
      data={data}
      options={chartOptions}
      plugins={[ChartDataLabels]} // Ensure the plugin is used
    >
      <div>{label}</div>
    </Doughnut>
  )
}

export default DountChart
